import { create } from 'zustand';

export type Theme = 'dark' | 'light';

const THEME_KEY = 'kmdx.theme';

function readTheme(): Theme {
  try {
    return localStorage.getItem(THEME_KEY) === 'light' ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
}

function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  root.classList.toggle('light', theme === 'light');
  root.classList.toggle('dark', theme === 'dark');
  try {
    localStorage.setItem(THEME_KEY, theme);
  } catch {
    /* без съхранение — темата важи само за сесията */
  }
}

interface UiState {
  theme: Theme;
  searchOpen: boolean;
  shortcutsOpen: boolean;
  /** Листът „Още" от долната лента — само на тесен екран. */
  moreOpen: boolean;
  sidebarCollapsed: boolean;
  setTheme: (theme: Theme) => void;
  toggleTheme: () => void;
  setSearchOpen: (open: boolean) => void;
  setShortcutsOpen: (open: boolean) => void;
  setMoreOpen: (open: boolean) => void;
  toggleSidebar: () => void;
}

export const useUi = create<UiState>((set, get) => ({
  theme: readTheme(),
  searchOpen: false,
  shortcutsOpen: false,
  moreOpen: false,
  sidebarCollapsed: false,
  setTheme: (theme) => {
    applyTheme(theme);
    set({ theme });
  },
  toggleTheme: () => get().setTheme(get().theme === 'dark' ? 'light' : 'dark'),
  setSearchOpen: (searchOpen) => set({ searchOpen }),
  setShortcutsOpen: (shortcutsOpen) => set({ shortcutsOpen }),
  setMoreOpen: (moreOpen) => set({ moreOpen }),
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
}));
